import React, { createContext, useContext, useEffect, useRef, useState } from "react";

import { Toast } from "components/Toast";

const ToastContext = createContext();

const useToastContext = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToastContext must be used within a ToastProvider");
  }
  return ctx;
};

const ToastProvider = ({ children }) => {
  const [showToast, setShowToast] = useState(false);
  const [toast, setToast] = useState(null);
  const durationRef = useRef();

  useEffect(() => {
    return () => {
      clearTimeout(durationRef.current);
    };
  }, []);

  const notify = ({ title, description, type = "info", duration = 3000 }) => {
    setToast({ title, description, duration, type });
    setShowToast(true);

    if (durationRef.current) {
      clearTimeout(durationRef.current);
    }

    durationRef.current = setTimeout(() => {
      setShowToast(false);
    }, duration);
  };

  const hide = () => {
    clearTimeout(durationRef.current);
    setShowToast(false);
  };

  return (
    <ToastContext.Provider value={{ notify }}>
      {children}
      <Toast show={showToast} setShow={hide} title={toast?.title} description={toast?.description} type={toast?.type} />
    </ToastContext.Provider>
  );
};

export { useToastContext, ToastContext, ToastProvider };
